const ProductCarousel = {
  SELECTORS: {
    container: '[data-js-product-carousel]',
  },
  init() {
    this.initializeCarousels(document);
  },
  initializeCarousels(parentElement) {
    const containerElements = parentElement.querySelectorAll(this.SELECTORS.container);

    containerElements.forEach((containerElement) => {
      new Swiper(containerElement, {
        slidesPerView: 'auto',
        // Arrows move a screenful of books at a time instead of one.
        slidesPerGroupAuto: true,
        // Free scrolling: the row glides with drag, swipe or trackpad instead of stepping book by book.
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 1.2,
          momentumVelocityRatio: 1.4,
          momentumBounce: false,
        },
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1.5,
        },
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600,
        watchOverflow: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  ProductCarousel.init();
});

document.addEventListener('shopify:section:load', () => {
  ProductCarousel.init();
});

document.addEventListener('shopify:section:reorder', () => {
  ProductCarousel.init();
});

window.ProductCarousel = ProductCarousel;
